import { useCallback } from 'react';
import type { ComponentProps, Fragment } from 'react';
import type React from 'react';

import { LazyComponent, ScrollableComponent } from 'src/app/shared/components/layout/lazy';
import type { SuggestedPetitionsProps } from 'src/app/shared/components/suggestedPetitionsSunrise';

export const SuggestedPetitionsLazy: React.FC<SuggestedPetitionsProps & ComponentProps<typeof Fragment>> = (props) => {
	const loadComponent = useCallback(
		async () =>
			(
				await import(
					/* webpackChunkName: "cmp/suggested_petitions" */ 'src/app/shared/components/suggestedPetitionsSunrise'
				)
			).SuggestedPetitions,
		[],
	);

	return (
		<ScrollableComponent topOffset={200} immediateForBots>
			{/* eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions */}
			<LazyComponent loadComponent={loadComponent} {...(props as any)} />
		</ScrollableComponent>
	);
};
